import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';

import {fuseAnimations} from '@fuse/animations';

@Component({
    selector: 'notification-list-sidebar',
    templateUrl: './list-sidebar.component.html',
    styleUrls: ['./list-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class NotificationListSidebarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    loadingIndicator: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.loadingIndicator = true;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * New notification
     */
    newNotification(): void {
        this._router.navigate(['/settings/notifications/new']).then(() => {

        });
    }
}
